export default __webpack_public_path__ + "static/media/Algaecide.bb6e52a6.jpg";